<template>
    <div class="background">
        <a-icon
            class="failed-icon"
            theme="filled"
            type="close-circle" />
        <div class="title">
            设备激活失败
        </div>
        <div class="error-area">
            <div
                v-for="(error, index) in errors"
                :key="index"
                class="error-item">
                {{ error }}
            </div>
        </div>
        <div class="bottom-button-area">
            <div
                v-on:click="ok"
                class="button">
                完成
            </div>
        </div>
    </div>
</template>

<script>
 export default {
     name: 'OpenDoorFailed',
     data() {
         return {
             errors: [],
         }
     },
     props: {
     },
     components: {
     },
     mounted() {
         this.errors = JSON.parse(sessionStorage.getItem("openDoorFailedInfo"))
     },
     methods: {
         ok() {
             this.$router.replace("/home")
         }
     }
 }
</script>

<style scoped>
 .background {
     width: 100%;
     height: 100%;
     position: relative;
 }

 .title {
     font-size: 30px;
     padding-top: 20px;
 }

 .device-number {
     font-size: 20px;
     font-weight: bold;
     margin-top: 10px;
     margin-bottom: 10px;
 }

 .bottom-button-area {
     width: 100%;
     position: absolute;
     bottom: 30px;
     display: flex;
     flex-direction: row;
     justify-content: center;
 }

 .button {
     width: 50%;
     background-color: #20273E;
     height: 40px;
     border-radius: 50px;
     color: white;
     font-size: 15px;
     border: none;
     display: flex;
     flex-direction: column;
     align-items: center;
     justify-content: center;
 }

 .error-block {
     background-color: #FFF;
     box-shadow: #B4B4B4 0 0 5px 0;
     margin: 20px;
     padding: 10px;
     border-radius: 5px;
 }

 .error-title {
     font-size: 18px;
     text-align: start;
 }

 .error-fix {
     font-size: 14px;
     text-align: start;
     color: #666;
     margin-top: 10px;
 }

 .error-area {
     margin-top: 40px;
 }

 .error-item {
     color: #E60011;
     font-size: 20px;
     margin-top: 5px;
 }

 .failed-icon {
     margin-top: 20px;
     font-size: 60px;
     color: #E60011;
 }
</style>
